import {CountryCode} from 'libphonenumber-js';

export const getAlpha2CodeByAlpha3code = (alpha3: Alpha3CountryCode): CountryCode =>
  countryAlphaCodesMap[alpha3];

export const getAlpha3CodeByAlpha2code = (alpha2: CountryCode): Alpha3CountryCode =>
  alphaCountryCodesMap[alpha2];

type CountryAlphaCodesMap = {
  [key in Alpha3CountryCode]: CountryCode;
};

type AlphaCountryCodesMap = {
  [key in CountryCode]: Alpha3CountryCode;
};

export const countryAlphaCodesMap = {
  ASC: 'AC',
  AND: 'AD',
  ARE: 'AE',
  AFG: 'AF',
  ATG: 'AG',
  AIA: 'AI',
  ALB: 'AL',
  ARM: 'AM',
  AGO: 'AO',
  ARG: 'AR',
  ASM: 'AS',
  AUT: 'AT',
  AUS: 'AU',
  ABW: 'AW',
  ALA: 'AX',
  AZE: 'AZ',
  BIH: 'BA',
  BRM: 'BB',
  BDG: 'BD',
  BEL: 'BE',
  BFA: 'BF',
  BGR: 'BG',
  BHR: 'BH',
  BDI: 'BI',
  BEN: 'BJ',
  BLM: 'BL',
  BMU: 'BM',
  BRN: 'BN',
  BOL: 'BO',
  BES: 'BQ',
  BRA: 'BR',
  BHS: 'BS',
  BTN: 'BT',
  BWA: 'BW',
  BLR: 'BY',
  BLZ: 'BZ',
  CAN: 'CA',
  CCK: 'CC',
  COD: 'CD',
  CAF: 'CF',
  COG: 'CG',
  CHE: 'CH',
  CIV: 'CI',
  COK: 'CK',
  CHL: 'CL',
  CMR: 'CM',
  CHN: 'CN',
  COL: 'CO',
  CRI: 'CR',
  CUB: 'CU',
  CPV: 'CV',
  CUW: 'CW',
  CXR: 'CX',
  CYP: 'CY',
  CZE: 'CZ',
  DEU: 'DE',
  DJI: 'DJ',
  DNK: 'DK',
  DMA: 'DM',
  DOM: 'DO',
  DZA: 'DZ',
  ECU: 'EC',
  EST: 'EE',
  EGY: 'EG',
  ESH: 'EH',
  ERI: 'ER',
  ESP: 'ES',
  ETH: 'ET',
  FIN: 'FI',
  FJI: 'FJ',
  FLK: 'FK',
  FSM: 'FM',
  FRO: 'FO',
  FRA: 'FR',
  GAB: 'GA',
  GBR: 'GB',
  GRD: 'GD',
  GEO: 'GE',
  GUF: 'GF',
  GGY: 'GG',
  GHA: 'GH',
  GIB: 'GI',
  GRL: 'GL',
  GMB: 'GM',
  GIN: 'GN',
  GLP: 'GP',
  GNQ: 'GQ',
  GRC: 'GR',
  GTM: 'GT',
  GUM: 'GU',
  GNB: 'GW',
  GUY: 'GY',
  HKG: 'HK',
  HND: 'HN',
  HRV: 'HR',
  HTI: 'HT',
  HUN: 'HU',
  IDN: 'ID',
  IRL: 'IE',
  ISR: 'IL',
  IMN: 'IM',
  IND: 'IN',
  IOT: 'IO',
  IRQ: 'IQ',
  IRN: 'IR',
  ISL: 'IS',
  ITA: 'IT',
  JEY: 'JE',
  JAM: 'JM',
  JOR: 'JO',
  JPN: 'JP',
  KEN: 'KE',
  KGZ: 'KG',
  KHM: 'KH',
  KIR: 'KI',
  COM: 'KM',
  KNA: 'KN',
  KPR: 'KP',
  KOR: 'KR',
  KWT: 'KW',
  CYM: 'KY',
  KAZ: 'KZ',
  LAO: 'LA',
  LBN: 'LB',
  LCA: 'LC',
  LIE: 'LI',
  LKA: 'LK',
  LBR: 'LR',
  LSO: 'LS',
  LTU: 'LT',
  LUX: 'LU',
  LVA: 'LV',
  LBY: 'LY',
  MAR: 'MA',
  MCO: 'MC',
  MDA: 'MD',
  MNE: 'ME',
  MAF: 'MF',
  MDG: 'MG',
  MHL: 'MH',
  MKD: 'MK',
  MLI: 'ML',
  MMR: 'MM',
  MNG: 'MN',
  MAC: 'MO',
  MNP: 'MP',
  MTQ: 'MQ',
  MRT: 'MR',
  MSR: 'MS',
  MLT: 'MT',
  MUS: 'MU',
  MDV: 'MV',
  MWI: 'MW',
  MEX: 'MX',
  MYS: 'MY',
  MOZ: 'MZ',
  NAM: 'NA',
  NCL: 'NC',
  NER: 'NE',
  NFK: 'NF',
  NGA: 'NG',
  NIC: 'NI',
  NLD: 'NL',
  NOR: 'NO',
  NPL: 'NP',
  NRU: 'NR',
  NIU: 'NU',
  NZL: 'NZ',
  OMN: 'OM',
  PAN: 'PA',
  PER: 'PE',
  PYF: 'PF',
  PNG: 'PG',
  PHL: 'PH',
  PAK: 'PK',
  POL: 'PL',
  SPM: 'PM',
  PRI: 'PR',
  PSE: 'PS',
  PRT: 'PT',
  PLW: 'PW',
  PRY: 'PY',
  QAT: 'QA',
  REU: 'RE',
  ROU: 'RO',
  SRB: 'RS',
  RUS: 'RU',
  RWA: 'RW',
  SAU: 'SA',
  SLB: 'SB',
  SYC: 'SC',
  SDN: 'SD',
  SWE: 'SE',
  SGP: 'SG',
  SHN: 'SH',
  SVN: 'SI',
  SJM: 'SJ',
  SVK: 'SK',
  SLE: 'SL',
  SMR: 'SM',
  SEN: 'SN',
  SOM: 'SO',
  SRU: 'SR',
  SSD: 'SS',
  STP: 'ST',
  SLV: 'SV',
  SXM: 'SX',
  SYR: 'SY',
  SWZ: 'SZ',
  TAA: 'TA',
  TCA: 'TC',
  TCD: 'TD',
  TGO: 'TG',
  THA: 'TH',
  TJK: 'TJ',
  TKL: 'TK',
  TLS: 'TL',
  TMK: 'TM',
  TUN: 'TN',
  TON: 'TO',
  TUR: 'TR',
  TTO: 'TT',
  TVU: 'TV',
  TWN: 'TW',
  TZA: 'TZ',
  UKR: 'UA',
  UGA: 'UG',
  USA: 'US',
  URY: 'UY',
  UZB: 'UZ',
  VAT: 'VA',
  VCT: 'VC',
  VEN: 'VE',
  VGB: 'VG',
  VIR: 'VI',
  VNM: 'VN',
  VUT: 'VU',
  WLF: 'WF',
  WSM: 'WS',
  XXK: 'XK',
  YEM: 'YE',
  MYT: 'YT',
  ZAF: 'ZA',
  ZMB: 'ZM',
  ZWE: 'ZW',
} as CountryAlphaCodesMap;

const alphaCountryCodesMap = {
  AC: 'ASC',
  AD: 'AND',
  AE: 'ARE',
  AF: 'AFG',
  AG: 'ATG',
  AI: 'AIA',
  AL: 'ALB',
  AM: 'ARM',
  AO: 'AGO',
  AR: 'ARG',
  AS: 'ASM',
  AT: 'AUT',
  AU: 'AUS',
  AW: 'ABW',
  AX: 'ALA',
  AZ: 'AZE',
  BA: 'BIH',
  BB: 'BRM',
  BD: 'BDG',
  BE: 'BEL',
  BF: 'BFA',
  BG: 'BGR',
  BH: 'BHR',
  BI: 'BDI',
  BJ: 'BEN',
  BL: 'BLM',
  BM: 'BMU',
  BN: 'BRN',
  BO: 'BOL',
  BQ: 'BES',
  BR: 'BRA',
  BS: 'BHS',
  BT: 'BTN',
  BW: 'BWA',
  BY: 'BLR',
  BZ: 'BLZ',
  CA: 'CAN',
  CC: 'CCK',
  CD: 'COD',
  CF: 'CAF',
  CG: 'COG',
  CH: 'CHE',
  CI: 'CIV',
  CK: 'COK',
  CL: 'CHL',
  CM: 'CMR',
  CN: 'CHN',
  CO: 'COL',
  CR: 'CRI',
  CU: 'CUB',
  CV: 'CPV',
  CW: 'CUW',
  CX: 'CXR',
  CY: 'CYP',
  CZ: 'CZE',
  DE: 'DEU',
  DJ: 'DJI',
  DK: 'DNK',
  DM: 'DMA',
  DO: 'DOM',
  DZ: 'DZA',
  EC: 'ECU',
  EE: 'EST',
  EG: 'EGY',
  EH: 'ESH',
  ER: 'ERI',
  ES: 'ESP',
  ET: 'ETH',
  FI: 'FIN',
  FJ: 'FJI',
  FK: 'FLK',
  FM: 'FSM',
  FO: 'FRO',
  FR: 'FRA',
  GA: 'GAB',
  GB: 'GBR',
  GD: 'GRD',
  GE: 'GEO',
  GF: 'GUF',
  GG: 'GGY',
  GH: 'GHA',
  GI: 'GIB',
  GL: 'GRL',
  GM: 'GMB',
  GN: 'GIN',
  GP: 'GLP',
  GQ: 'GNQ',
  GR: 'GRC',
  GT: 'GTM',
  GU: 'GUM',
  GW: 'GNB',
  GY: 'GUY',
  HK: 'HKG',
  HN: 'HND',
  HR: 'HRV',
  HT: 'HTI',
  HU: 'HUN',
  ID: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IM: 'IMN',
  IN: 'IND',
  IO: 'IOT',
  IQ: 'IRQ',
  IR: 'IRN',
  IS: 'ISL',
  IT: 'ITA',
  JE: 'JEY',
  JM: 'JAM',
  JO: 'JOR',
  JP: 'JPN',
  KE: 'KEN',
  KG: 'KGZ',
  KH: 'KHM',
  KI: 'KIR',
  KM: 'COM',
  KN: 'KNA',
  KP: 'KPR',
  KR: 'KOR',
  KW: 'KWT',
  KY: 'CYM',
  KZ: 'KAZ',
  LA: 'LAO',
  LB: 'LBN',
  LC: 'LCA',
  LI: 'LIE',
  LK: 'LKA',
  LR: 'LBR',
  LS: 'LSO',
  LT: 'LTU',
  LU: 'LUX',
  LV: 'LVA',
  LY: 'LBY',
  MA: 'MAR',
  MC: 'MCO',
  MD: 'MDA',
  ME: 'MNE',
  MF: 'MAF',
  MG: 'MDG',
  MH: 'MHL',
  MK: 'MKD',
  ML: 'MLI',
  MM: 'MMR',
  MN: 'MNG',
  MO: 'MAC',
  MP: 'MNP',
  MQ: 'MTQ',
  MR: 'MRT',
  MS: 'MSR',
  MT: 'MLT',
  MU: 'MUS',
  MV: 'MDV',
  MW: 'MWI',
  MX: 'MEX',
  MY: 'MYS',
  MZ: 'MOZ',
  NA: 'NAM',
  NC: 'NCL',
  NE: 'NER',
  NF: 'NFK',
  NG: 'NGA',
  NI: 'NIC',
  NL: 'NLD',
  NO: 'NOR',
  NP: 'NPL',
  NR: 'NRU',
  NU: 'NIU',
  NZ: 'NZL',
  OM: 'OMN',
  PA: 'PAN',
  PE: 'PER',
  PF: 'PYF',
  PG: 'PNG',
  PH: 'PHL',
  PK: 'PAK',
  PL: 'POL',
  PM: 'SPM',
  PR: 'PRI',
  PS: 'PSE',
  PT: 'PRT',
  PW: 'PLW',
  PY: 'PRY',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  RW: 'RWA',
  SA: 'SAU',
  SB: 'SLB',
  SC: 'SYC',
  SD: 'SDN',
  SE: 'SWE',
  SG: 'SGP',
  SH: 'SHN',
  SI: 'SVN',
  SJ: 'SJM',
  SK: 'SVK',
  SL: 'SLE',
  SM: 'SMR',
  SN: 'SEN',
  SO: 'SOM',
  SR: 'SRU',
  SS: 'SSD',
  ST: 'STP',
  SV: 'SLV',
  SX: 'SXM',
  SY: 'SYR',
  SZ: 'SWZ',
  TA: 'TAA',
  TC: 'TCA',
  TD: 'TCD',
  TG: 'TGO',
  TH: 'THA',
  TJ: 'TJK',
  TK: 'TKL',
  TL: 'TLS',
  TM: 'TMK',
  TN: 'TUN',
  TO: 'TON',
  TR: 'TUR',
  TT: 'TTO',
  TV: 'TVU',
  TW: 'TWN',
  TZ: 'TZA',
  UA: 'UKR',
  UG: 'UGA',
  US: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  VA: 'VAT',
  VC: 'VCT',
  VE: 'VEN',
  VG: 'VGB',
  VI: 'VIR',
  VN: 'VNM',
  VU: 'VUT',
  WF: 'WLF',
  WS: 'WSM',
  XK: 'XXK',
  YE: 'YEM',
  YT: 'MYT',
  ZA: 'ZAF',
  ZM: 'ZMB',
  ZW: 'ZWE',
} as AlphaCountryCodesMap;

export type Alpha3CountryCode =
  | 'ASC'
  | 'AND'
  | 'ARE'
  | 'AFG'
  | 'ATG'
  | 'AIA'
  | 'ALB'
  | 'ARM'
  | 'AGO'
  | 'ARG'
  | 'ASM'
  | 'AUT'
  | 'AUS'
  | 'ABW'
  | 'ALA'
  | 'AZE'
  | 'BIH'
  | 'BRM'
  | 'BDG'
  | 'BEL'
  | 'BFA'
  | 'BGR'
  | 'BHR'
  | 'BDI'
  | 'BEN'
  | 'BLM'
  | 'BMU'
  | 'BRN'
  | 'BOL'
  | 'BES'
  | 'BRA'
  | 'BHS'
  | 'BTN'
  | 'BWA'
  | 'BLR'
  | 'BLZ'
  | 'CAN'
  | 'CCK'
  | 'COD'
  | 'CAF'
  | 'COG'
  | 'CHE'
  | 'CIV'
  | 'COK'
  | 'CHL'
  | 'CMR'
  | 'CHN'
  | 'COL'
  | 'CRI'
  | 'CUB'
  | 'CPV'
  | 'CUW'
  | 'CXR'
  | 'CYP'
  | 'CZE'
  | 'DEU'
  | 'DJI'
  | 'DNK'
  | 'DMA'
  | 'DOM'
  | 'DZA'
  | 'ECU'
  | 'EST'
  | 'EGY'
  | 'ESH'
  | 'ERI'
  | 'ESP'
  | 'ETH'
  | 'FIN'
  | 'FJI'
  | 'FLK'
  | 'FSM'
  | 'FRO'
  | 'FRA'
  | 'GAB'
  | 'GBR'
  | 'GRD'
  | 'GEO'
  | 'GUF'
  | 'GGY'
  | 'GHA'
  | 'GIB'
  | 'GRL'
  | 'GMB'
  | 'GIN'
  | 'GLP'
  | 'GNQ'
  | 'GRC'
  | 'GTM'
  | 'GUM'
  | 'GNB'
  | 'GUY'
  | 'HKG'
  | 'HND'
  | 'HRV'
  | 'HTI'
  | 'HUN'
  | 'IDN'
  | 'IRL'
  | 'ISR'
  | 'IMN'
  | 'IND'
  | 'IOT'
  | 'IRQ'
  | 'IRN'
  | 'ISL'
  | 'ITA'
  | 'JEY'
  | 'JAM'
  | 'JOR'
  | 'JPN'
  | 'KEN'
  | 'KGZ'
  | 'KHM'
  | 'KIR'
  | 'COM'
  | 'KNA'
  | 'KPR'
  | 'KOR'
  | 'KWT'
  | 'CYM'
  | 'KAZ'
  | 'LAO'
  | 'LBN'
  | 'LCA'
  | 'LIE'
  | 'LKA'
  | 'LBR'
  | 'LSO'
  | 'LTU'
  | 'LUX'
  | 'LVA'
  | 'LBY'
  | 'MAR'
  | 'MCO'
  | 'MDA'
  | 'MNE'
  | 'MAF'
  | 'MDG'
  | 'MHL'
  | 'MKD'
  | 'MLI'
  | 'MMR'
  | 'MNG'
  | 'MAC'
  | 'MNP'
  | 'MTQ'
  | 'MRT'
  | 'MSR'
  | 'MLT'
  | 'MUS'
  | 'MDV'
  | 'MWI'
  | 'MEX'
  | 'MYS'
  | 'MOZ'
  | 'NAM'
  | 'NCL'
  | 'NER'
  | 'NFK'
  | 'NGA'
  | 'NIC'
  | 'NLD'
  | 'NOR'
  | 'NPL'
  | 'NRU'
  | 'NIU'
  | 'NZL'
  | 'OMN'
  | 'PAN'
  | 'PER'
  | 'PYF'
  | 'PNG'
  | 'PHL'
  | 'PAK'
  | 'POL'
  | 'SPM'
  | 'PRI'
  | 'PSE'
  | 'PRT'
  | 'PLW'
  | 'PRY'
  | 'QAT'
  | 'REU'
  | 'ROU'
  | 'SRB'
  | 'RUS'
  | 'RWA'
  | 'SAU'
  | 'SLB'
  | 'SYC'
  | 'SDN'
  | 'SWE'
  | 'SGP'
  | 'SHN'
  | 'SVN'
  | 'SJM'
  | 'SVK'
  | 'SLE'
  | 'SMR'
  | 'SEN'
  | 'SOM'
  | 'SRU'
  | 'SSD'
  | 'STP'
  | 'SLV'
  | 'SXM'
  | 'SYR'
  | 'SWZ'
  | 'TAA'
  | 'TCA'
  | 'TCD'
  | 'TGO'
  | 'THA'
  | 'TJK'
  | 'TKL'
  | 'TLS'
  | 'TMK'
  | 'TUN'
  | 'TON'
  | 'TUR'
  | 'TTO'
  | 'TVU'
  | 'TWN'
  | 'TZA'
  | 'UKR'
  | 'UGA'
  | 'USA'
  | 'URY'
  | 'UZB'
  | 'VAT'
  | 'VCT'
  | 'VEN'
  | 'VGB'
  | 'VIR'
  | 'VNM'
  | 'VUT'
  | 'WLF'
  | 'WSM'
  | 'XXK'
  | 'YEM'
  | 'MYT'
  | 'ZAF'
  | 'ZMB'
  | 'ZWE';
